<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
          <el-button type="success" plain @click="onImprot">导入</el-button>
            <el-button type="success" @click="onExport">导出</el-button>
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template slot-scope="{row}">
            <el-button v-if="$permission.canWrite()" type="text" @click="edit(row)">编辑</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
     <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/basedata/inventory/packingspeci/list";
import editDialog from "@/components/basedata/inventory/packingspeci/editDialog";
import importDialog from "@/components/basedata/inventory/packingspeci/importDialog";

export default {
  name: "packingspeci",
  mixins: [curdMixins],
  components: {
    list,
     importDialog,
    editDialog,
  },

  methods: {
     onImprot() {
      this.$refs.importDialog.open();
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.PackingSpeciId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>